import React, { useState, useEffect } from 'react';

interface ParallaxHeroProps {
  image: string;
  title: string;
  subtitle?: string;
  smallTitle?: boolean;
  backgroundPosition?: string;
  backgroundSize?: string;
}

const ParallaxHero: React.FC<ParallaxHeroProps> = ({ image, title, subtitle, smallTitle, backgroundPosition = 'center', backgroundSize = 'cover' }) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-[50vh] md:h-[60vh] min-h-[350px] flex items-center justify-center overflow-hidden mt-24 md:mt-32">
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url('${image}')`,
          backgroundSize: backgroundSize,
          backgroundPosition: backgroundPosition,
          transform: `scale(${1 + scrollY * 0.0003}) translateY(${scrollY * 0.25}px)`,
          willChange: 'transform',
        }}
      />
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative z-10 text-center px-4">
        <h1 className={`font-serif font-black text-friet-beige mb-4 drop-shadow-2xl uppercase tracking-wider italic ${smallTitle ? 'text-2xl sm:text-3xl md:text-4xl lg:text-5xl' : 'text-4xl sm:text-5xl md:text-6xl lg:text-7xl'}`} style={{ textShadow: '0 4px 20px rgba(0,0,0,0.4)' }}>
          {title}
        </h1>
        {subtitle && (
          <p className="font-script text-friet-beige/90 text-2xl sm:text-3xl md:text-4xl drop-shadow-lg" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default ParallaxHero;
